<!-- This component defines the base shape/style and functionality of all
modals and should be imported into any other modal components that you create. Look
at the custom modal components to see how this is incorporated -->
<template>
  <div
    class="modal is-active"
  >
    <div
      class="modal-background"
    />
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">
          <slot name="header" />
        </div>
        <button
          v-if="hasCloseButton"
          class="delete is-default"
          aria-label="close"
          @click="$root.$emit('close::custom::modal')"
        />
      </header>
      <section class="modal-card-body">
        <slot name="content" />
      </section>
      <footer class="modal-card-foot">
        <div v-if="$slots.footer">
          <slot name="footer" />
        </div>
        <div v-else>
          <div
            v-show="successMessage"
            class="is-size-5 label has-text-success"
          >
            <font-awesome-icon
              icon="check-circle"
              class="is-medium has-text-success"
            />
            {{ successMessage }}
          </div>
          <div
            v-show="errorMessage"
            class="is-size-5 label has-text-danger"
          >
            <font-awesome-icon
              icon="exclamation-triangle"
              class="is-medium has-text-danger"
            />
            {{ errorMessage }}
          </div>
          <div>
            <button
              v-if="hasCancelButton"
              class="button is-large is-primary is-broad is-uppercase"
              :disabled="showLoading"
              @click="handleNegative"
            >
              {{ btnCancelText }}
            </button>
            <button
              v-if="hasOkButton"
              class="button is-large is-primary is-broad is-uppercase"
              :class="{'is-loading': showLoading}"
              @click="handleAffirmative"
            >
              {{ btnOkText }}
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>

export default {

  name: 'ModalStructure',
  props: {
    modal: {
      type: Object,
      default: () => {}
    },
    btnCancelText: {
      type: String,
      default: 'Cancel'
    },
    btnOkText: {
      type: String,
      default: 'Ok'
    },
    hasOkButton: {
      type: Boolean,
      default: true
    },
    hasCancelButton: {
      type: Boolean,
      default: true
    },
    disableOkButton: {
      type: Boolean,
      default: false
    },
    affirmativeHandler: {
      type: Function,
      default: () => {}
    },
    negativeHandler: {
      type: Function,
      default: () => {}
    },
    hasCloseButton: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    successMessage: {
      type: String,
      default: ''
    },
    showLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleAffirmative () {
      this.affirmativeHandler()
    },
    handleNegative () {
      this.negativeHandler()
      this.$root.$emit('close::custom::modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  z-index: 300;
}
.modal-background {
  opacity: .6;
}

.modal-card-head, .modal-card-foot, .modal-card-body {
  background-color: #e7eefb;
  border: none;
}

.modal-card-foot {
  justify-content: flex-end;

  @media screen and (max-width: 400px), print {
    .button {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}

.modal-card-body {
  color: black;
  text-align: center;
  // display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0;
}

.modal-wrapper {
  z-index: 40;
}

.modal-card {
  position: relative;
  transition: top .3s;
  top: 0;
  max-width: 90%;
}
</style>
